module.exports = __webpack_public_path__ + "img/contact_phone.220d0705.png";